// Prefer persisted domain IDs. Unsaved editable rows receive _uiId ON CREATION,
// never during render; it survives immutable updates but is not sent to the API.
const transientKeys = new WeakMap();
let nextKey = 0;
const FIELDS = ['_uiId','member_uuid','membership_number','change_id','audit_id','log_id','invite_id','token_id','document_id','registration_id','ticket_id','order_id','refund_id','event_id','coupon_id','user_id','subscriber_id','id','_id','key'];
export const stableRecordKey = record => {
  if (record === null || typeof record !== 'object') return `${typeof record}:${String(record)}`;
  for (const field of FIELDS) if (record[field] !== undefined && record[field] !== null) return `${field}:${String(record[field])}`;
  if (!transientKeys.has(record)) transientKeys.set(record, `row:${++nextKey}`);
  return transientKeys.get(record);
};
export const withRowId = row => ({ ...row, _uiId: row._uiId || crypto.randomUUID() });

export const retainRowIdentity = (previous, next) => {
  transientKeys.set(next, stableRecordKey(previous));
  return next;
};
